import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { faClose } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { faArrowRight } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { gql } from '@soundxyz/gql-string';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { useAuth } from '@context/auth/base';
import { useBackendUserPersistedData } from '@hooks/useBackendUserPersistedData';
import { NAV_LINKS, SPACE } from '@utils/constants';

/*#__PURE__*/ gql(/* GraphQL */ `
  mutation SetDismissFeedBanner($data: JSON!) {
    setUserPersistedData(data: $data) {
      ... on MutationSetUserPersistedDataSuccess {
        data
      }

      ... on ValidationError {
        message
      }
    }
  }
`);

export const NewFeedFeatureBanner = () => {
  const { isAuthenticatedWithAPI } = useAuth();
  const { hasDismissedNewPostFeatureBanner, setHasDismissedNewPostFeatureBanner } =
    useBackendUserPersistedData();

  const hasBanner =
    !isAuthenticatedWithAPI ||
    (isAuthenticatedWithAPI && hasDismissedNewPostFeatureBanner.type === 'not-dismissed');

  if (!hasBanner) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.3 }}
      className=" relative flex w-full items-center justify-center bg-base900 px-4 py-4 font-base text-base-m text-white lg:px-6"
    >
      <AccessibleLink
        absoluteUri={NAV_LINKS.Feed}
        type="external"
        className="before:absolute before:bottom-0 before:left-0 before:right-0 before:top-0 before:content-['']"
      />

      <div className="inline-flex w-full max-w-content items-center justify-center ">
        <span className="hidden lg:block">🎙{SPACE}</span>
        <span className="font-semibold">Post & earn when anyone collects</span>
        <span className="hidden lg:block">
          .{SPACE}
          Share songs on the feed
        </span>
        <FontAwesomeIcon
          icon={faArrowRight}
          className="ml-2 font-base text-base100"
          fontSize={16}
        />
      </div>

      {isAuthenticatedWithAPI && (
        <div className="absolute right-1 md:right-4">
          <IconButton
            icon={<FontAwesomeIcon icon={faClose} className="z-above1  font-base text-base100" />}
            iconSize={16}
            variant="inverted"
            onClick={() => {
              setHasDismissedNewPostFeatureBanner(true);
            }}
          />
        </div>
      )}
    </motion.div>
  );
};
